import React from "react";
import "./style.scss";

// "Question 2 of 10" with a bar filled to the same fraction (20%).
export const QuestionProgress = ({ current, total }) => {
  const safeCurrent = Number(current) || 0;
  const percent = total > 0 ? Math.min(100, Math.round((safeCurrent / total) * 100)) : 0;
  return (
    <div className="question-progress">
      <div className="question-progress__label">
        Question <span className="question-progress__current">{safeCurrent}</span> of {total}
      </div>
      <div
        className="question-progress__track"
        role="progressbar"
        aria-label="Question progress"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={safeCurrent}
        aria-valuetext={`Question ${safeCurrent} of ${total}`}
      >
        <div className="question-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};
